import React, { useContext } from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import Login from "./components/auth/Login";
import Users from "./components/users/Users";
import NewUser from "./components/users/NewUser";
import EditUser from "./components/users/EditUser";
import Navbar from "./components/layout/Navbar";
import AuthContext from "./context/AuthContext";
import MachineryList from "./components/machinery/MachineryList";
import NewMachinery from "./components/machinery/NewMachinery";
import CurrentOrders from "./components/orders/CurrentOrders";
import EditMachinery from "./components/machinery/EditMachinery";
import ServiceList from "./components/machinery/ServiceList";
import NewService from "./components/machinery/NewService";
import EditService from "./components/machinery/EditService";
import Stats from "./components/stats/Stats";
import Start from "./components/layout/Start";
import Profil from "./components/users/Profil";

function Router() {
  const { loggedIn } = useContext(AuthContext);

  return (
    <BrowserRouter>
      <Navbar />
      <main>
        <div className="max-w-full mx-auto py-6 sm:px-6 lg:px-8">
          <div className="px-4 py-6 sm:px-0">
            <Switch>
              {loggedIn === false && (
                <>
                  <Redirect to="/login" />
                  <Route path="/login">
                    <Login />
                  </Route>
                </>
              )}
              {loggedIn === true && (
                <>
                  <Route exact path="/stats">
                    <Stats />
                  </Route>
                  <Route exact path="/users">
                    <Users />
                  </Route>
                  <Route exact path="/profil">
                    <Profil />
                  </Route>
                  <Route exact path="/users/new">
                    <NewUser />
                  </Route>
                  <Route path="/users/edit/:id">
                    <EditUser />
                  </Route>
                  <Route exact path="/historie">
                    <CurrentOrders />
                  </Route>
                  <Route exact path="/equipment">
                    <MachineryList />
                  </Route>
                  <Route exact path="/equipment/new">
                    <NewMachinery />
                  </Route>
                  <Route exact path="/equipment/edit/:id">
                    <EditMachinery />
                  </Route>
                  <Route exact path="/equipment/services/:id">
                    <ServiceList />
                  </Route>
                  <Route exact path="/equipment/service/new/:id">
                    <NewService />
                  </Route>
                  <Route exact path="/equipment/services/edit/:id">
                    <EditService />
                  </Route>
                  <Route exact path="/">
                    <Start />
                  </Route>
                </>
              )}
            </Switch>
          </div>
        </div>
      </main>
    </BrowserRouter>
  );
}

export default Router;
